import { render, staticRenderFns } from "./foip-statement.vue?vue&type=template&id=fdb6c580&"
import script from "./foip-statement.vue?vue&type=script&lang=js&"
export * from "./foip-statement.vue?vue&type=script&lang=js&"
import style0 from "./foip-statement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports